import { useAppActions } from 'reducers/slices/realEstateAgent/waitlistLoanOfficersSlice';
import { pathOr } from 'ramda';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { loadLoanOfficers, loadMoreLoanOfficers, approveLoanOfficer, batchApproveLoanOfficers } = useAppActions();
  const { loanOfficers, meta, loanOfficersLoadingStatus, updatingStatus, batchUpdatingStatus } = useSelector(
    state => state.waitlistLoanOfficersSlice,
  );

  const totalCount = pathOr(null, ['totalCount'], meta);

  return {
    isLoanOfficersLoading: useFetchStatus(loanOfficersLoadingStatus).isPending,
    isLoanOfficersIdle: useFetchStatus(loanOfficersLoadingStatus).isIdle,
    loanOfficers,
    loadLoanOfficers,
    totalCount,
    meta,
    loadMoreLoanOfficers,
    approveLoanOfficer,
    batchApproveLoanOfficers,
    isUpdating: useFetchStatus(updatingStatus).isPending,
    isBatchUpdating: useFetchStatus(batchUpdatingStatus).isPending,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/realEstateAgent/useWaitlistLoanOfficers.js